import { TrashIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';

import { deleteSSHKnownHost } from '../../hooks/use_delivery_api';
import { routes } from '../../router';
import { DeleteModal } from '../core/delete_modal';
import { createToast } from '../core/toast';

interface SSHKnownHostDeleteModalProps {
  projectId: string;
  hostId: string;
}

export function SSHKnownHostDeleteModal(props: SSHKnownHostDeleteModalProps) {
  const [open, setOpen] = useState(false);

  const onSubmit = async () => {
    try {
      await deleteSSHKnownHost({
        name: `projects/${props.projectId}/sshKnownHosts/${props.hostId}`,
      });
      createToast(`SSH known host "${props.hostId}" deleted.`);
      routes.sshKnownHostList({
        projectId: props.projectId,
      }).push();
    } catch (err) {
      createToast(`Error deleting SSH known host: ${err}`);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        <TrashIcon className="-ml-0.5 mr-2 h-5 w-5" aria-hidden="true" />
        Remove
      </button>
      <DeleteModal
        title="Remove SSH known host"
        description={`Are you sure you want to delete ${props.hostId}? This action cannot be undone.`}
        action="Remove"
        onSubmit={onSubmit}
        setOpen={setOpen}
        open={open}
      />
    </>
  );
}
